export const DEFAULT_MEETINGS_ORDER_BY = ['start_utc'];

export const MEETING_STATUS_PENDING = 0,
    MEETING_STATUS_CONFIRMED = 1,
    MEETING_STATUS_CANCELLED = -1;
